import { apiInterfaceForJson } from "../common/apiManager";

export const fetchLogs = () => {
    return apiInterfaceForJson("/log/v1/", "GET");
};

export const fetchAvailableLogs = () => {
    return apiInterfaceForJson("/log/v1/available", "GET");
};

export const searchLogs = (query) => {
    return apiInterfaceForJson("/log/v1/search", "POST", query);
};

export const getLogDataById = (logId) => {
    return apiInterfaceForJson("/log/v1/" + logId, "GET");
};

export const createLog = (logDetails) => {
    return apiInterfaceForJson("/log/v1/", "POST", logDetails);
};

export const updateLog = (logDetails) => {
    return apiInterfaceForJson("/log/v1/", "PUT", logDetails);
};

export const updateLogBackgroundThemeColor = (logDetails) => {
    return apiInterfaceForJson("/log/v1/update", "POST", logDetails);
};

export const updateDevice = (deviceDetails) => {
    let logDeviceInfo = {
        _id: deviceDetails.id,
        device_id: deviceDetails.deviceId
    };
    return apiInterfaceForJson("/log/v1/updateDevice", "POST", logDeviceInfo);
};

export const deleteLog = (logDetails) => {
    return apiInterfaceForJson("/log/v1/delete", "POST", logDetails);
};
